(function () {

    /** sign up form service **/
    SUGApp.service('authenticationService', ['SUGUtilities', function(util){

        var service = {};

        service.logoutUser = function(){
            return util.APISyncCall( "post", "", "", "c.logoutUser", 15000 );
        };

        service.forgotPassword = function( data ){
            return util.APISyncCall( "post", "", data, "c.forgotPassword", 15000 );
        };

        service.loginUser = function( data ){
            return util.APISyncCall( "post", "", data, "c.loginUser", 20000 );
        };

        service.createMember = function( data ){
            return util.APISyncCall( "post", "", data, "c.createMember", 15000 );
        };

        service.verifyDisabledAccount = function( data ){
            return util.APISyncCall( "post", "", data, "c.verifyDisabledAccount", 15000 );
        };

        service.getsmappid = function( data ){
            return util.APISyncCall( "post", "", data, "c.getsmappid", 15000 );
        };

        service.getMainNavigation = function(data){
            return util.APISyncCall( "post", "", data, "c.getMainNavigation", 15000 );
        };

        service.passwordRulesText = function(){
            return util.APISyncCall( "post", "", "", "c.passwordRulesText", 15000 );
        };

        service.validatePasswordRules = function(data){
            return util.APISyncCall( "post", "", data, "c.validatePasswordRules", 15000 );
        };

		service.getLoginRateLimit = function(data){
			return util.APISyncCall( "post", "", data, "c.getLoginRateLimit", 15000 );
		};

		service.changePassword = function(data){
			return util.APISyncCall( "post", "", data, "c.changePassword", 15000 );
		};

        service.resultErrorHandler = function( response ){
    		var Message = "";
    		var result = util.lowerCaseKeys(response);
    		if( angular.isDefined(result.message) ){
    			if( angular.isArray(result.message) ){
                    angular.forEach( result.message, function(obj,key){
                        Message += obj + " ";
                    });
    			} else {
    				Message = result.message;
    			}
    		} else {
    			if( util.isDefinedNotNullNotEmpty(result.statustext) ){
    				Message = result.statustext;
    			} else if( typeof result.status !== undefined && result.status === 0 ){
    				Message = 'Request timeout exceeded. Make sure you are logged in and have an active session.';
    			}
    			else {
    				Message = 'An unknown error occurred while processing your request';
    			}
    		}

    		return Message;
    	};

        return service;

    }]);

})();
